"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProductsSummaryFull = void 0;
const get_products_summary_full_stream_1 = require("./get-products-summary-full-stream");
const stream_1 = require("../../stream");
const getProductsSummaryFull = (client) => async () => {
    return (0, stream_1.unwrapStream)(await (0, get_products_summary_full_stream_1.getProductsSummaryFullStreamResponse)(client)());
};
exports.getProductsSummaryFull = getProductsSummaryFull;
